import clsx from 'clsx'

export default function Loading({ noMargin }: { noMargin?: boolean }) {
    return (
        <div className={clsx('flex justify-center', !noMargin && 'my-20')}>
            <span className="loading loading-spinner loading-lg"></span>
        </div>
    )
}
